// extracted by mini-css-extract-plugin
module.exports = {"lds__spinner":"style_lds__spinner__22Kh8","large__spinner":"style_large__spinner__2eKk-"};